import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import FaqSection from './FaqSection'
import Footer from '../../components/footer/Footer'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { Link } from 'react-router-dom';
import CtaSection from '../../components/CtaSection/CtaSection';

const FaqPage = () => {
    return (
        <Fragment>
            <Navbar hclass={'header-style-1'} />
            <PageTitle pageTitle={'Frequently Asked Questions'} pagesub={'FAQ'} />
            <section className="faq-pg-section section-padding">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col col-xl-6  col-lg-8 col-md-10 col-12">
                            <div className="section-title">
                                <p>For your convenience, our most common questions are answered right here.
                                    <br />
                                    
                                    You can also reach out to us through our <Link to="/contact">Contact</Link> page!</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col col-xs-12">
                            <FaqSection />
                        </div>
                    </div>
                </div>
            </section>
            <CtaSection />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default FaqPage;

